import Link from 'next/link';
import { AppConfig } from '@/utils/AppConfig';
import DateLabel from '../date/DateLabel';
import Pin from '../../../../public/png/find_icon.png';
import Image from 'next/image';
import CategoryLabel from '../category/CategoryLabel';
export interface TableJobItemProps {
  id: string;
  contract_type?: string;
  contract_duration?: string;
  city?: string;
  title?: string;
  job_start?: string;
  unit?: string;
  service?: string;
  date_published?: string;
}
export default function TableJobItem({
  id,
  contract_type,
  contract_duration,
  city,
  title,
  job_start,
  unit,
  service,
  date_published,
}: TableJobItemProps) {
  return (
    <div
      key={id}
      className="mt-[20px] flex h-[110px] w-full items-start rounded-md bg-white p-5 lg:mb-0 lg:mt-0 lg:h-[69px] lg:items-center lg:pl-[83px] lg:pr-[89px]"
    >
      <div className="lg:flew-col relative flex w-full flex-col justify-between lg:ml-2 lg:flex-row lg:items-center lg:gap-2.5">
        <div className="w-24 truncate">
          {contract_type ? <CategoryLabel category={contract_type} /> : ''}
        </div>
        <div className="inline-flex w-24 items-center truncate pt-[15px] lg:py-0">
          <Image src={Pin} width={20} height={20} alt={`Lieu : ${city}`} />
          <span className="ml-[10px] text-sm font-bold text-slate-500">
            {city?.toUpperCase() || ''}
          </span>
        </div>
        <div className="w-full truncate py-[15px] uppercase lg:w-1/2 lg:py-0">
          <Link
            href={`${AppConfig.websiteBasePublicUrl}/emplois/${id}`}
            target="_blank"
            className="text-sm font-bold text-slate-950"
          >
            {title}{' '}
          </Link>
        </div>
        <div className="min-w-36 max-w-40">
          {job_start ? (
            <div className="text-nowrap text-sm text-slate-500">
              Début de contrat <DateLabel isoDate={job_start} type="MMM yyyy" />
            </div>
          ) : (
            ''
          )}
        </div>
      </div>
    </div>
  );
}
